import { forgetPasswordRoutes } from './forget-password/forget-password.routing';

import { Route } from '@angular/router';
import { loginRoutes } from './login/login.routing';
import { NotFoundComponent } from './shared/common/not-found/not-found.component';
import { ErrorPageComponent } from './shared/common/error-page/error-page.component';
import { kubaRoutes } from './kuba/kuba.routing';
import { SdsPublicPreviewComponent } from './kuba/safety-data-sheet/components/sds-public-preview.component';
import { SdsPublicListComponent } from './kuba/safety-data-sheet/components/sds-public-list.component';
import { RespondentSurveyComponent } from './kuba/employees/work-environment-survey/respondent/respondent-survey.component';

export const appRoutes: Route[] = [
  {
    path: '',
    children: [
      {
        path: '',
        children: [
          {
            path: 'safety-data-sheets/share/:token',
            component: SdsPublicPreviewComponent,
          },
          {
            // Anonymous chemical list opened by scanning a business' QR code.
            // Sits above kubaRoutes so it never picks up the authenticated shell or its guards.
            path: 'safety-data-sheets/public/:token',
            component: SdsPublicListComponent,
          },
          // Public: the employee answering the work environment survey follows
          // an invitation link and is not necessarily a Kuba user, so this
          // route is deliberately outside kubaRoutes and has no AuthGuard.
          {
            path: 'work-environment-survey/respondent/:respondentId',
            component: RespondentSurveyComponent,
          },
          // Public: the anonymous deviation form a reporter opens by scanning a business's QR
          // code. Outside kubaRoutes so it has no AuthGuard, and loaded on its own, so the form,
          // its photo handling and Turnstile are not in the bundle every signed-in user loads.
          {
            path: 'deviation/qr/:token',
            loadComponent: () =>
              import('./kuba/follow-ups/components/deviation-qr-public/deviation-qr-public.component').then(
                m => m.DeviationQrPublicComponent
              ),
          },
          ...kubaRoutes,
          ...loginRoutes,
          ...forgetPasswordRoutes,
        ],
      },
      {
        path: 'not-found',
        component: NotFoundComponent,
      },
      {
        path: 'error-page/:code',
        component: ErrorPageComponent,
      },
      {
        // Last resort, so an unmatched URL renders a page instead of an empty router-outlet,
        // which is the blank page NG04002 leaves behind. Reached by a stale in-app link, by a
        // popup opened with a base href the route table cannot match (see getBaseLocation), and
        // by /safety-data-sheets/public with no token and no trailing slash — with the slash
        // still on, :token binds to '' and the chemical list handles it itself.
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
];
